export default {
  NAME: 'shintaro',
  getStorage_: function () {
    const json = localStorage.getItem(this.NAME)
    return json ? JSON.parse(json) : {}
  },
  setStorage_: function (obj) {
    localStorage.setItem(this.NAME, JSON.stringify(obj))
  },
  get: function (key, default_) {
    const obj = this.getStorage_()
    return key in obj ? obj[key] : default_ !== undefined ? default_ : null
  },
  set: function (key, val) {
    const obj = this.getStorage_()
    obj[key] = val
    this.setStorage_(obj)
  },
  remove: function (key) {
    const obj = this.getStorage_()
    if (key in obj) delete obj[key]
    this.setStorage_(obj)
  },
  removeAll: function () {
    localStorage.clear()
  }
}
